<template>
  <div>
    <docu-about :delFlag="false"></docu-about>
  </div>
</template>

<script>
import DocuAbout from '@/views/component/docuCommon/docuAbout';

export default {
  name: 'CustAddAbout',
  components: { DocuAbout }
};
</script>

<style scoped></style>
